import { useMemo } from 'react';
import { htcmdService } from 'js/services/htcmd.service';
import { useHTCMDPublicAPI as coreUseHTCMDPublicAPI } from 'js/hooks/usePublicAPI/hooks/useHTCMDPublicAPI';

export const useHTCMDPublicAPI = () => {
    const htcmdPublicAPI = coreUseHTCMDPublicAPI();
    const { goToExternalPage, openLogin, sendDeviceIdCommand } = htcmdService;

    return useMemo(() => ({
        ...htcmdPublicAPI,
        /**
         * Send 'goToExternalPage?pageUrl=url' command to Native application with url.
         * @memberOf Playtech.API.htcmd
         * @function
         * @param {string} url - The URL of the external page to navigate to.
         */
        goToExternalPage,

        /**
         * Send 'openLogin' command to Native application.
         * @memberOf Playtech.API.htcmd
         * @type String
         */
        openLogin,

        /**
         * Send 'authentication/AuthenticationDeviceID' command to Native application.
         * @memberOf Playtech.API.htcmd
         * @function
         */
        sendDeviceIdCommand
    }), [
        openLogin,
        htcmdPublicAPI,
        goToExternalPage,
        sendDeviceIdCommand
    ]);
};
